import { useTranslation } from 'react-i18next';
import { useConfirmDialog } from 'contexts/ConfirmDialog';
import { CONFIRM_DIALOG_DEFAULT_VALUE } from 'appConstants';

export default function useFieldOfficeLocation(transNamespace: string) {
  const { t } = useTranslation(transNamespace);
  const confirmDialog = useConfirmDialog();

  const officeLocationChangeDialog = async (value, productsCount: number) => {
    const { confirmed } =
      value && productsCount
        ? await confirmDialog({
            title: t('dialogs.officeLocationChange.title'),
            message: t('dialogs.officeLocationChange.description'),
            onActionLabel: t('dialogs.officeLocationChange.buttonPrimary'),
          })
        : CONFIRM_DIALOG_DEFAULT_VALUE;

    return confirmed;
  };

  return {
    officeLocationChangeDialog,
  };
}
